import { useMutation, UseMutationOptions } from '@tanstack/react-query'
import { RequestTypes } from '../requestTypes'
import {
  APIAxiosInstance,
  RequestErrorType,
} from '@core/utils/api-axios-instance'
import { useUploadFile } from './useUploadFile'
import { createQueryKeyString } from '@core/react-query/queryParams'

export type TranscribeAudioResponse = {
  id: number
  s3_key: string
  transcript: string
  created_on: string
}

export const useTranscribeAudio = (
  options?: UseMutationOptions<
    TranscribeAudioResponse,
    RequestErrorType,
    RequestTypes['transcribeAudio']
  >,
) => {
  const uploadMutation = useUploadFile()

  return useMutation({
    mutationKey: [null],
    mutationFn: async (payload: RequestTypes['transcribeAudio']) => {
      const s3Key = await uploadMutation.mutateAsync(payload)
      const queryString = createQueryKeyString({
        s3_key: s3Key,
      })
      const { data } = await APIAxiosInstance.get(
        `${Project.apiBaseUrl}data/workflow/transcribe${queryString}`,
      )
      return data
    },
    ...options,
  })
}
